export default "__VITE_ASSET__DtdmbwIF__"